import React , {useContext} from 'react';
import { WindowWidthContext } from '../../context/user-details-context';

export default function ActionIconItem({ title, content, isExpanded, toggleAccordion, index  }) {
    const windowWidth = useContext(WindowWidthContext);

    return (
        <div className="border border-[#00000033] border-solid rounded-[5px] max-xs:mx-4 w-[650px] xl:w-[850px] max-xs:w-auto "     style={{  width: windowWidth >= 799 && windowWidth <= 1024 ? '700px' : undefined,}}>
            <div className="flex justify-between items-center cursor-pointer gap-[92px] h-[50px] xl:px-6 px-4 xl:h-[80px] max-xs:gap-6" onClick={() => toggleAccordion(index)}>
                <div className="text-18 font-normal font-sans xl:text-24 max-xs:text-16 text-[#010101] leading-[24.51px] xl:leading-[32.68px]">{title}</div>
                <div >
                    <div >
                        <img src="https://assets-global.website-files.com/5ef4691542433bca43839ceb/5f1e9d16771fe4ea4c4045b5_expand_more_icon.svg" alt="" className="w-6 xl:w-9" onClick={toggleAccordion} style={{ display: isExpanded ? 'none' : 'block' }} />
                    </div>
                    <div >
                        <img src="https://assets-global.website-files.com/5ef4691542433bca43839ceb/5f1e9d1637b7ab2877f980f5_expand_less_icon.svg" alt="" className="w-6 xl:w-9 " onClick={toggleAccordion} style={{ display: isExpanded ? 'block' : 'none' }} />
                    </div>
                </div>
            </div>
            <div style={{ height: isExpanded ? "auto" : 0, display: isExpanded ? 'block' : 'none' }} className='w-[650px] xl:w-[850px] max-xs:w-auto'>
                <div className='px-4 py-4 xl:px-6 xl:py-[32px] font-sans font-light text-16 xl:text-20 text-[#010101] leading-[21.79px] xl:leading-[27.24px]'>
                    {content}
                </div>
            </div>
        </div>
    );
}
